import React, {useState} from 'react';
import {
  Col,
  CustomInput,
  FormGroup,
  Input,
  Label,
  FormText,
  FormFeedback,
} from 'reactstrap';
import NumberFormat from 'react-number-format';

export function FieldLabel({htmlFor, children, ...rest}) {
  return (
    <Label htmlFor={htmlFor} {...rest}>
      {children}
    </Label>
  );
}

export function FieldInput(props) {
  let input;

  const {format, defaultValue, type} = props;

  const [textLength, setTextLength] = useState(
    defaultValue ? defaultValue.length : 0
  );

  if (format) {
    const {format, mask, id, name, type, ...rest} = props;

    input = (
      <NumberFormat
        className="form-control"
        type={type}
        id={id || name}
        name={name}
        format={format}
        mask={mask}
        {...rest}
      />
    );
  } else if (type === 'select') {
    const {id, name, type, options, ...rest} = props;

    input = (
      <CustomInput type={type} id={id || name} name={name} {...rest}>
        {Object.keys(options).map((option, key) => {
          return (
            <option key={key} value={option}>
              {options[option]}
            </option>
          );
        })}
      </CustomInput>
    );
  } else if (type === 'textarea') {
    const {name, type, defaultValue, maxLength, onChange, ...rest} = props;

    const handleChange = (e) => {
      setTextLength(e.target.value.length);

      if (onChange) {
        onChange(e);
      }
    };

    input = (
      <>
        <Input
          type={type}
          id={name}
          name={name}
          defaultValue={defaultValue}
          maxLength={maxLength}
          onChange={handleChange}
          {...rest}
        />
        {maxLength && (
          <FormText className="text-right">{`${textLength} / ${maxLength}`}</FormText>
        )}
      </>
    );
  } else {
    const {name, type, ...rest} = props;

    input = <Input type={type} id={name} name={name} {...rest} />;
  }

  return input;
}

function FormField({
  row,
  label,
  name,
  placeholder,
  type,
  options,
  children,
  className,
  defaultValue,
  style,
  help,
  feedback,
  required,
  ...rest
}) {
  const columnLabel = row ? {lg: 3} : {};
  const columnInput = row ? {lg: 9, xl: 6} : {};

  return (
    <FormGroup row={row} className={className} style={style}>
      {label && (
        <FieldLabel {...columnLabel} htmlFor={name}>
          {label}
          {required && <span className="text-danger"> * </span>}
        </FieldLabel>
      )}

      {React.createElement(
        row ? Col : 'div',
        {...columnInput},
        <React.Fragment>
          {type && (
            <FieldInput
              defaultValue={defaultValue}
              type={type}
              name={name}
              placeholder={placeholder || label}
              options={options}
              {...rest}
              required={required}
            />
          )}
          {children}
          {feedback && <FormFeedback>{feedback}</FormFeedback>}
          {help && <FormText>{help}</FormText>}
        </React.Fragment>
      )}
    </FormGroup>
  );
}

FormField.defaultProps = {
  autoComplete: 'off',
};

export default FormField;
